export default {
  isModalOpen(state) {
    return !!state.modals.length;
  },
  activeModal(state) {
    return state.modals.length ? state.modals[state.modals.length - 1] : null;
  },
};
